import {Card, FormControl} from 'platform/components';
import {VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {ArticleUpdateJobSource} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';
import {ArticlesScopeForm} from './ArticlesScopeForm';
import {BasicInformationForm} from './BasicInformationForm';
import {UpdateScopeForm} from './UpdateScopeForm';

interface GeneralInformationTabProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
  source: ArticleUpdateJobSource | Nullish;
}

export function GeneralInformationTab(props: GeneralInformationTabProps) {
  return (
    <Card title={i18n.t('entity.warehouse.labels.basicInformation')}>
      <VStack spacing={4}>
        <BasicInformationForm
          control={props.control}
          source={props.source}
          data-testid={suffixTestId('basicInformation', props)}
        />
        <ArticlesScopeForm
          control={props.control}
          formApi={props.formApi}
          source={props.source}
          data-testid={suffixTestId('articlesScope', props)}
        />
        <UpdateScopeForm
          control={props.control}
          formApi={props.formApi}
          data-testid={suffixTestId('updateScope', props)}
        />
      </VStack>
    </Card>
  );
}
